import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Typography,
  Card,
  CardActions,
  CardBody,
  CardMedia,
  CardTitle
} from '@one-thd/sui-atomic-components';

const ProDeskCardGrid = ({ title, data, trackingParam, ctaText }) => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-3" data-component="ProDeskCardGrid">
      <Typography variant="h2">{title}</Typography>
      <div className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 lg:sui-grid-cols-4 sui-gap-4">
        {data.map(({
          title: cardTitle, description, imageUrl, ctaUrl
        }) => {
          const href = `${ctaUrl}${trackingParam}`;
          return (
            <Card key={cardTitle}>
              <CardMedia src={imageUrl} alt={cardTitle} aspect="wide" />
              <CardTitle header={cardTitle} />
              <CardBody>
                <Typography>{description}</Typography>
              </CardBody>
              <CardActions>
                <a href={href} className="hover:sui-no-underline">
                  <Button fullWidth variant="text">
                    {ctaText}
                  </Button>
                </a>
              </CardActions>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

ProDeskCardGrid.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      imageUrl: PropTypes.string,
      ctaUrl: PropTypes.string
    })
  ).isRequired,
  trackingParam: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired
};

ProDeskCardGrid.displayName = 'ProDeskCardGrid';

export default ProDeskCardGrid;